import { html } from "lit-html";
import { CachedObjectState } from "./AdminPageViewModel";
import { submitActionOnlyPost } from "./adminCommon";
import { useAjax } from "Services/useAjax";

export interface Props {
	isPreview: boolean;
	state: CachedObjectState;
}

export const useSitemapSection = (props: Props) => {
	const { ajaxRequest } = useAjax();

	const invalidate = async (e: MouseEvent) => {
		e.preventDefault();
		e.stopPropagation();
		await submitActionOnlyPost("invalidate_sitemap", ajaxRequest);
	};

	const invalidTemplate = () => html`
		<ul class="list-none text-xs leading-normal text-[#db0000]">
			<li><span class="font-bold uppercase">Message:</span> ${props.state.LastRefreshMessage}</li>
			<li><span class="font-bold uppercase">Refreshed On:</span> ${props.state.RefreshedOn}</li>
		</ul>
	`;

	const validTemplate = () => html`
		<ul class="list-none text-xs leading-normal text-n-dark-gray">
			<li><span class="font-bold uppercase">Expires On:</span> ${props.state.ExpiresOn}</li>
			<li><span class="font-bold uppercase">Refreshed On:</span> ${props.state.RefreshedOn}</li>
			<li><span class="font-bold uppercase">Cache State:</span> ${props.state.CacheState}</li>
		</ul>
	`;

	const buttonTemplate = () => html`
		<button type="submit" class="bg-n-blue hover:bg-n-red hover:text-white" value="Invalidate" @click=${invalidate}>
			Invalidate
		</button>
	`;

	const htmlTemplate = () => html`
		<section class="mt-6 flex justify-between gap-4">
			${!props.isPreview
				? html` ${props.state.IsValid ? validTemplate() : invalidTemplate()} ${buttonTemplate()}`
				: html`<div class="w-full">
						<label class="preview-label">In Preview</label>
				  </div>`}
		</section>
	`;

	return { htmlTemplate };
};
